
import { Component, Prop, Vue, Provide, Mixins } from 'vue-property-decorator'
import lodash from 'lodash'
import { MixinsCourseDownTime } from '@xt/client/mixins'
@Component({
  components: {}
})
export default class PageView extends Mixins(MixinsCourseDownTime) {
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
